/* eslint-disable react/prop-types */ // TODO: add props
import { LinkedChecklist } from '../LinkedChecklist';
import AnnotatedImageWrapper from './AnnotatedImageWrapper';

const AnnotatedImageChecklist = ({
  checklistItems,
  checklistReflections,
  onChecklistReflection,
  disabled,
  imageUrl,
  checklistImageAnnotations,
  isSaving,
}) => {
  return (
    <LinkedChecklist
      checklistItems={checklistItems}
      checklistReflections={checklistReflections}
      onChecklistReflection={onChecklistReflection}
      renderLinkedComponent={(highlightedSerial, setHighlightedSerial) => {
        return (
          <AnnotatedImageWrapper
            imageUrl={imageUrl}
            checklistImageAnnotations={checklistImageAnnotations}
            highlightedItemSerial={Number(highlightedSerial)}
            setHighlightedSerial={setHighlightedSerial}
          />
        );
      }}
      isSaving={isSaving}
    />
  );
};

export default AnnotatedImageChecklist;
